import React from 'react';
import ViolationsTranslatorContent from './ViolationsTranslatorContent';

export default function ViolationsPage() {
  return <ViolationsTranslatorContent embedded={false} />;
}
